import { useId } from 'react'
import { TextInput } from '../input/text-input.tsx'
import { PROJECT_DESCRIPTION_MAX_LENGTH, PROJECT_NAME_MAX_LENGTH } from './project-constants.ts'

export type ProjectDetailsFieldsProps = {
  name: string
  onNameChange: (name: string) => unknown
  /** Why the name was refused — a taken name is the one failure the typist can fix in place. */
  nameError?: string
  description: string
  onDescriptionChange: (description: string) => unknown
}

/** A project's Name and Description fields, shared by the create and edit dialogs so the two cannot drift. */
export const ProjectDetailsFields: React.FC<ProjectDetailsFieldsProps> = ({
  name,
  onNameChange,
  nameError,
  description,
  onDescriptionChange,
}) => {
  const nameId = useId()
  const descriptionId = useId()
  return (
    <>
      <TextInput
        size="small"
        id={nameId}
        label="Name"
        explicitLabelCondition="optional"
        value={name}
        maxLength={PROJECT_NAME_MAX_LENGTH}
        onChange={onNameChange}
        isError={nameError !== undefined}
        errorText={nameError}
        isRequired
      />
      <TextInput
        size="small"
        id={descriptionId}
        label="Description"
        explicitLabelCondition="optional"
        value={description}
        maxLength={PROJECT_DESCRIPTION_MAX_LENGTH}
        onChange={onDescriptionChange}
      />
    </>
  )
}
